import * as z from "zod";

/**
 * Coarse, code-owned sort outcome that code branches on (ADR 0002). Distinct
 * from the merchant-facing ReturnItemDispositionRule. Extend via
 * `ALTER TYPE sort_disposition ADD VALUE` plus an entry here.
 */
export const SortDisposition = {
  restock: "restock",
  consolidation: "consolidation",
  liquidation: "liquidation",
  damaged: "damaged",
  problem: "problem",
  refurbishment: "refurbishment",
} as const;
export type SortDisposition =
  (typeof SortDisposition)[keyof typeof SortDisposition];

export const SortDispositionSchema = z.enum([
  SortDisposition.restock,
  SortDisposition.consolidation,
  SortDisposition.liquidation,
  SortDisposition.damaged,
  SortDisposition.problem,
  SortDisposition.refurbishment,
]);
